import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { setReopenModal } from 'actions/App';
import { fetchUnitList, deleteLock } from 'actions/Units';
import TableNew from 'components/TableNew';
import LoadingIndicator from 'components/LoadingIndicator';
import ButtonContained from 'components/ButtonContained';
import IconWithBackground from 'components/IconWithBackground';

const LockTransferModal = ({ lock, unit }) => {
    const dispatch = useDispatch();
    const intl = useIntl();
    const unitsList = useSelector((state) => state.units.unitsList);
    const [selectedUnit, setSelectedUnit] = useState(null);

    const handleSelectionChange = (units) => {
        const filteredUnits = unitsList.filter((u) => u.uuid === units[0]);
        setSelectedUnit(filteredUnits[0] ?? null);
    };

    useEffect(() => {
        dispatch(fetchUnitList(['available']));
    }, [dispatch]);

    const handleTransfer = () => {
        dispatch(
            deleteLock(
                {
                    lockUUID: lock.uuid,
                    unitName: selectedUnit.name,
                    zoneUUID: '-1',
                    mac: lock.mac,
                    name: lock.name,
                    type: lock.hwType,
                    accessType: selectedUnit.accessType
                },
                {
                    successMessage: intl.formatMessage({ id: 'notifications.success.edit' }),
                    unitUUID: unit.id
                }
            )
        );
    };

    return unitsList ? (
        <div className="space-y-2 px-10 min-h-[40vh] max-h-[70vh] flex flex-col">
            <p className="tw-paragraph-sm mb-8">{intl.formatMessage({ id: 'comp.header.select.unitTransfer' })}.</p>
            <TableNew
                data={unitsList}
                defaultSortKey="name"
                searchableKeys={['name']}
                singleSelect={true}
                showHeaders={false}
                fullWidthSearch={false}
                onSelectionChange={handleSelectionChange}
                icon={
                    <IconWithBackground
                        iconName="closedDoor"
                        backgroundColor="#E7E7E7"
                        className="text-[var(--color-gray-300)]"
                    />
                }
                maxHeight="max-h-[200px]"
                columns={[
                    {
                        key: 'name',
                        label: intl.formatMessage({ id: 'comp.table.header.unit' }),
                        sortable: true
                    }
                ]}
            />
            <div className="flex gap-2 justify-start mt-4">
                <ButtonContained
                    id="Lock-Transfer-Modal-Transfer-Button"
                    dataCy="Lock-Transfer-Modal-Transfer-Button"
                    text={intl.formatMessage({ id: 'comp.button.transfer.locks' })}
                    type="default"
                    disabled={!selectedUnit}
                    onClick={() => handleTransfer()}
                />
                <ButtonContained
                    id="Lock-Transfer-Modal-Cancel-Button"
                    dataCy="Lock-Transfer-Modal-Cancel-Button"
                    text={intl.formatMessage({ id: 'comp.button.cancel' })}
                    type="defaultOutline"
                    onClick={() => dispatch(setReopenModal({ unitUUID: unit.id }))}
                />
            </div>
        </div>
    ) : (
        <div className="flex justify-center">
            <LoadingIndicator />
        </div>
    );
};

export default LockTransferModal;
